/* =========================================================================
   AIRLUMA - Ancre courte "#avis" vers la section Avis de la page d'accueil.

   Pourquoi : le menu pointait sur
   #shopify-section-template--<numero>__a_pillova_reviews_...
   Ce numero est genere par Shopify et change a chaque republication de
   theme. Resultat : une URL illisible ET un lien qui casse.

   Ici on cible la section par un motif stable (a_pillova_reviews) et on
   gere le defilement, aussi bien depuis la home que depuis une autre page.
   ========================================================================= */
(function () {
  var ANCHOR = 'avis';
  var SELECTOR = '[id*="a_pillova_reviews"]';
  var OFFSET = 80;

  function section() {
    return document.querySelector(SELECTOR);
  }

  function goTo(smooth) {
    var el = section();
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.scrollY - OFFSET;
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }

  /* Arrivee sur la page avec #avis : on insiste quelques secondes, le temps
     que les images en lazy-load finissent de decaler la mise en page.
     On s'arrete des que l'utilisateur scrolle lui-meme. */
  function onHash() {
    if (location.hash !== '#' + ANCHOR) return;
    var stop = false;
    function halt() { stop = true; }
    ['wheel', 'touchstart'].forEach(function (evt) {
      window.addEventListener(evt, halt, { passive: true, once: true });
    });
    var tries = 0;
    (function again() {
      if (stop) return;
      goTo(false);
      if (++tries < 16) setTimeout(again, 250);
    })();
  }

  /* Clic sur "Avis" alors qu'on est deja sur la home : pas de rechargement,
     on defile directement. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href$="#' + ANCHOR + '"]');
    if (!link || !section()) return;
    e.preventDefault();
    history.replaceState(null, '', '/#' + ANCHOR);
    goTo(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onHash);
  } else {
    onHash();
  }
  window.addEventListener('load', onHash);
})();